import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useIsMobile from '../hooks/useIsMobile';
import api from '../services/api';

function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [saldo, setSaldo] = useState(0);
  const [envios, setEnvios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const [saldoRes, enviosRes] = await Promise.all([
        api.get('/saldo'),
        api.get('/envios')
      ]);
      setSaldo(saldoRes.data.saldo);
      setEnvios(enviosRes.data.slice(0, 5));
    } catch (error) {
      console.error('Error al cargar datos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ fontSize: '1.25rem' }}>Cargando...</div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, overflow: 'auto' }}>
      {/* Header */}
      <nav style={{ backgroundColor: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 0.5rem' : '0 1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', height: isMobile ? '3.5rem' : '4rem', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src="/logo.png" alt="Logo" style={{ height: isMobile ? '5rem' : '10rem' }} />
            </div>

            {isMobile ? (
              <div style={{ position: 'relative' }}>
                <button
                  onClick={() => setMenuOpen(!menuOpen)}
                  style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', padding: '0.5rem' }}
                >
                  ☰
                </button>
                {menuOpen && (
                  <div style={{
                    position: 'absolute', right: 0, top: '100%', backgroundColor: 'white',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)', borderRadius: '0.5rem',
                    padding: '0.5rem', minWidth: '200px', zIndex: 1000
                  }}>
                    <div style={{ padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#374151', borderBottom: '1px solid #e5e7eb' }}>
                      {user?.razon_social || user?.nombre}
                    </div>
                    {user?.isAdmin && (
                      <button onClick={() => { navigate('/admin/dashboard'); setMenuOpen(false); }} style={{
                        width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: 'white',
                        backgroundColor: '#dc2626', border: 'none', cursor: 'pointer', textAlign: 'left', borderRadius: '0.25rem', marginTop: '0.25rem'
                      }}>🛡️ Admin</button>
                    )}
                    <button onClick={handleLogout} style={{
                      width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#374151',
                      backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left', marginTop: '0.25rem'
                    }}>Cerrar Sesión</button>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                {user?.isAdmin && (
                  <button onClick={() => navigate('/admin/dashboard')} style={{
                    padding: '0.5rem 1rem', fontSize: '0.875rem', color: 'white',
                    backgroundColor: '#dc2626', border: 'none', borderRadius: '0.375rem', cursor: 'pointer'
                  }}>🛡️ Admin</button>
                )}
                <span style={{ color: '#374151' }}>{user?.razon_social || user?.nombre}</span>
                <button onClick={handleLogout} style={{
                  padding: '0.5rem 1rem', fontSize: '0.875rem', color: '#374151',
                  backgroundColor: 'transparent', border: 'none', cursor: 'pointer'
                }}>Cerrar Sesión</button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '1rem 0.75rem' : '2rem 1rem' }}>
        <h1 style={{ fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 'bold', color: '#111827', marginBottom: isMobile ? '1rem' : '2rem' }}>
          Dashboard
        </h1>

        {/* Cards de resumen */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: isMobile ? '1rem' : '1.5rem',
          marginBottom: isMobile ? '1rem' : '2rem'
        }}>
          <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: isMobile ? '1rem' : '1.5rem' }}>
            <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>Saldo Disponible</div>
            <div style={{ fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 'bold', color: '#ff8c00' }}>
              ${parseFloat(saldo).toFixed(2)} MXN
            </div>
            <button onClick={() => navigate('/saldo')} style={{
              marginTop: '0.75rem', fontSize: '0.875rem', color: '#ff8c00',
              backgroundColor: 'transparent', border: 'none', cursor: 'pointer'
            }}>Recargar saldo →</button>
          </div>

          <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: isMobile ? '1rem' : '1.5rem' }}>
            <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>Total de Envíos</div>
            <div style={{ fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 'bold', color: '#111827' }}>{envios.length}</div>
            <button onClick={() => navigate('/mis-envios')} style={{
              marginTop: '0.75rem', fontSize: '0.875rem', color: '#ff8c00',
              backgroundColor: 'transparent', border: 'none', cursor: 'pointer'
            }}>Ver todos →</button>
          </div>

          <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: isMobile ? '1rem' : '1.5rem' }}>
            <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>Acciones Rápidas</div>
            <div style={{ display: 'flex', flexDirection: isMobile ? 'row' : 'column', gap: '0.5rem', marginTop: '0.75rem' }}>
              <button onClick={() => navigate('/cotizar')} style={{
                flex: 1, padding: '0.5rem 1rem', backgroundColor: '#ff8c00', color: 'white',
                borderRadius: '0.375rem', border: 'none', fontSize: '0.875rem', cursor: 'pointer'
              }}>Cotizar Envío</button>
              <button onClick={() => navigate('/crear-envio')} style={{
                flex: 1, padding: '0.5rem 1rem', border: '1px solid #ff8c00', color: '#ff8c00',
                backgroundColor: 'white', borderRadius: '0.375rem', fontSize: '0.875rem', cursor: 'pointer'
              }}>Crear Envío</button>
            </div>
          </div>
        </div>

        {/* Últimos envíos */}
        <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <div style={{ padding: isMobile ? '0.75rem 1rem' : '1rem 1.5rem', borderBottom: '1px solid #e5e7eb' }}>
            <h2 style={{ fontSize: isMobile ? '1rem' : '1.25rem', fontWeight: '600', color: '#111827' }}>Últimos Envíos</h2>
          </div>
          <div style={{ padding: isMobile ? '0.75rem' : '1.5rem' }}>
            {envios.length === 0 ? (
              <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem 0' }}>
                No tienes envíos aún. ¡Crea tu primer envío!
              </p>
            ) : isMobile ? (
              /* Vista de tarjetas en móvil */
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {envios.map((envio) => (
                  <div key={envio.id} style={{
                    border: '1px solid #e5e7eb', borderRadius: '0.5rem', padding: '0.75rem'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                      <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#111827' }}>{envio.numero_guia}</span>
                      <span style={{
                        padding: '0.25rem 0.5rem', fontSize: '0.7rem', borderRadius: '9999px',
                        backgroundColor: '#d1fae5', color: '#065f46'
                      }}>{envio.status}</span>
                    </div>
                    <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>{envio.destino_ciudad}, {envio.destino_estado}</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}>
                      <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>{envio.tipo_servicio}</span>
                      <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#111827' }}>${parseFloat(envio.costo_cliente).toFixed(2)}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              /* Vista de tabla en desktop */
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                      <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase' }}>Guía</th>
                      <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase' }}>Destino</th>
                      <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase' }}>Servicio</th>
                      <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase' }}>Costo</th>
                      <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase' }}>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {envios.map((envio, index) => (
                      <tr key={envio.id} style={{ borderBottom: index < envios.length - 1 ? '1px solid #e5e7eb' : 'none' }}>
                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#111827' }}>{envio.numero_guia}</td>
                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#6b7280' }}>{envio.destino_ciudad}, {envio.destino_estado}</td>
                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#6b7280' }}>{envio.tipo_servicio}</td>
                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#111827' }}>${parseFloat(envio.costo_cliente).toFixed(2)}</td>
                        <td style={{ padding: '0.75rem 1rem' }}>
                          <span style={{ padding: '0.25rem 0.5rem', fontSize: '0.75rem', borderRadius: '9999px', backgroundColor: '#d1fae5', color: '#065f46' }}>{envio.status}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
